import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconScissor from "@arco-design/web-react/icon/react-icon/IconScissor";
// ExcelFormBody 表格裁剪浮层。参考 umi/sub 项目中的 TableCropOverlay，
// 用 arco Button / Tooltip / Icon 重写。
import React from 'react';
/**
 * 在 ExcelFormBody 上叠加一条"裁剪线" + 剪刀按钮。
 * 父组件根据 mouseMove 计算 guide.top / left / width，传给本组件渲染。
 */
export function ExcelTableCropOverlay({
  visible,
  top,
  left,
  width,
  onConfirmCrop
}) {
  if (!visible) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top,
      left,
      width,
      height: 0,
      zIndex: 1000,
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '2px dashed #FA5D6A',
      width: '100%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    "data-crop-overlay-controls": "true",
    style: {
      position: 'absolute',
      top,
      left,
      width: 0,
      height: 0,
      zIndex: 1001,
      pointerEvents: 'auto'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    size: "mini",
    type: "primary",
    shape: "circle",
    icon: /*#__PURE__*/React.createElement(_IconScissor, {
      style: {
        fontSize: 12
      }
    }),
    onMouseDown: onConfirmCrop,
    style: {
      position: 'absolute',
      top: 0,
      left: width / 2,
      transform: 'translate(-50%, -50%)'
    }
  })));
}